import React from 'react';
import Icon from '../../../components/AppIcon';

const FunnelVisualization = ({ data }) => {
  if (!data || data?.length === 0) {
    return (
      <div className="bg-card rounded-xl border border-border shadow-therapeutic p-6">
        <div className="text-center text-muted-foreground text-sm py-8">
          No funnel data available
        </div>
      </div>
    );
  }

  const maxUsers = data?.[0]?.users || 1;

  return (
    <div className="bg-card rounded-xl border border-border shadow-therapeutic p-6">
      <div className="flex items-center gap-2 mb-6">
        <Icon name="Filter" size={20} className="text-primary" strokeWidth={2} />
        <h2 className="text-lg font-heading font-semibold text-foreground">
          Conversion Funnel Stages
        </h2>
      </div>
      <div className="space-y-4">
        {data?.map((stage, index) => {
          const widthPercentage = (stage?.users / maxUsers) * 100;
          const conversionRate = index > 0 ? ((stage?.users / data?.[index - 1]?.users) * 100)?.toFixed(1) : 100;
          const dropOffRate = index > 0 ? (100 - conversionRate)?.toFixed(1) : 0;

          return (
            <div key={stage?.stage} className="relative">
              {/* Stage Info */}
              <div className="flex items-center justify-between mb-2">
                <div className="flex items-center gap-2">
                  <span className="text-sm font-medium text-foreground">{stage?.stage}</span>
                  {stage?.description && (
                    <span className="text-xs text-muted-foreground">({stage?.description})</span>
                  )}
                </div>
                <div className="flex items-center gap-4">
                  <span className="text-sm font-semibold text-foreground">
                    {stage?.users?.toLocaleString()} users
                  </span>
                  {index > 0 && (
                    <span className="text-xs text-muted-foreground">
                      {conversionRate}% conversion
                    </span>
                  )}
                </div>
              </div>
              {/* Funnel Bar */}
              <div className="relative h-16 bg-muted/20 rounded-lg overflow-hidden">
                <div
                  className="absolute inset-y-0 left-0 bg-gradient-to-r from-primary to-primary/70 flex items-center justify-center transition-all duration-500"
                  style={{ width: `${widthPercentage}%` }}
                >
                  <span className="text-xs font-medium text-primary-foreground">
                    {((stage?.users / maxUsers) * 100)?.toFixed(1)}%
                  </span>
                </div>
              </div>
              {/* Drop-off Indicator */}
              {index > 0 && dropOffRate > 0 && (
                <div className="flex items-center gap-2 mt-2 text-xs text-error">
                  <Icon name="TrendingDown" size={14} strokeWidth={2} />
                  <span>{dropOffRate}% drop-off from previous stage</span>
                </div>
              )}
              {/* Connector Arrow */}
              {index < data?.length - 1 && (
                <div className="flex justify-center my-2">
                  <Icon name="ChevronDown" size={20} className="text-muted-foreground" strokeWidth={2} />
                </div>
              )}
            </div>
          );
        })}
      </div>
      {/* Summary Stats */}
      <div className="mt-6 pt-6 border-t border-border grid grid-cols-1 sm:grid-cols-3 gap-4">
        <div className="text-center">
          <p className="text-xs text-muted-foreground mb-1">Top of Funnel</p>
          <p className="text-lg font-semibold text-foreground">{data?.[0]?.users?.toLocaleString()}</p>
        </div>
        <div className="text-center">
          <p className="text-xs text-muted-foreground mb-1">Bottom of Funnel</p>
          <p className="text-lg font-semibold text-foreground">{data?.[data?.length - 1]?.users?.toLocaleString()}</p>
        </div>
        <div className="text-center">
          <p className="text-xs text-muted-foreground mb-1">Overall Conversion</p>
          <p className="text-lg font-semibold text-success">
            {((data?.[data?.length - 1]?.users / data?.[0]?.users) * 100)?.toFixed(1)}%
          </p>
        </div>
      </div>
    </div>
  );
};

export default FunnelVisualization;